<template>
  <div class="container">
    <div class="filter-container">
      <el-form :inline="true" :model="listQuery" class="form-inline">
        <el-form-item label="人物">
          <el-input v-model="listQuery.person" placeholder="请输入人物名称" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button type="primary" @click="handleCreate">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="list"
      border
      style="width: 100%"
      highlight-current-row
    >
      <el-table-column
        label="序号"
        width="80"
        type="index"
        align="center"
      />
      <el-table-column
        label="人物"
        width="150"
        prop="person"
        align="center"
      />
      <el-table-column
        label="事件时间"
        width="180"
        prop="event_time"
        align="center"
      />
      <el-table-column
        label="事件内容"
        prop="event"
      />
      <el-table-column
        label="添加时间"
        width="180"
        prop="add_time"
        align="center"
      />
      <el-table-column
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
    
    <!-- 编辑/新增对话框 -->
    <el-dialog 
      :title="dialogStatus === 'create' ? '新增大事记' : '编辑大事记'" 
      :visible.sync="dialogVisible" 
      width="600px"
      :close-on-click-modal="false"
      center
      append-to-body>
      <el-form ref="dataForm" :model="temp" :rules="rules" label-position="right" label-width="100px">
        <el-form-item label="人物" prop="person">
          <el-input v-model="temp.person" placeholder="请输入人物名称" ref="personInput" />
        </el-form-item>
        <el-form-item label="事件时间" prop="event_time">
          <el-date-picker
            v-model="temp.event_time"
            type="datetime"
            placeholder="选择日期时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="事件内容" prop="event">
          <el-input v-model="temp.event" type="textarea" :rows="4" placeholder="请输入事件内容" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus === 'create' ? createData() : updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGreatEvents, addGreatEvent, updateGreatEvent, deleteGreatEvent } from '@/api/great_event'

export default {
  name: 'GreatEvent',
  data() {
    return {
      list: [], // 数据列表
      total: 0, // 总记录数
      loading: false, // 加载状态
      dialogVisible: false, // 对话框可见性
      dialogStatus: '', // 对话框状态 create/update
      listQuery: { // 查询参数
        page: 1,
        size: 10,
        person: ''
      },
      temp: { // 临时数据，用于新增/编辑
        id: undefined,
        person: '',
        event_time: '',
        event: ''
      },
      rules: { // 表单验证规则
        person: [
          { required: true, message: '请输入人物名称', trigger: 'blur' }
        ],
        event_time: [
          { required: true, message: '请选择事件时间', trigger: 'change' }
        ],
        event: [
          { required: true, message: '请输入事件内容', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取数据列表
    getList() {
      this.loading = true
      getGreatEvents(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 处理查询
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    // 每页记录数变化
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getList()
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 重置表单
    resetTemp() {
      this.temp = {
        id: undefined,
        person: '',
        event_time: '',
        event: ''
      }
    },
    // 处理新增
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        // 自动聚焦到人物输入框
        setTimeout(() => {
          this.$refs.personInput && this.$refs.personInput.focus()
        }, 100)
      })
    },
    // 新增数据
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          addGreatEvent(this.temp).then(response => {
            this.list.unshift(response.data)
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '新增成功!'
            })
            this.getList() // 重新加载数据
          })
        }
      })
    },
    // 处理编辑
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // 复制一份，防止修改原数据
      this.dialogStatus = 'update'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        // 自动聚焦到人物输入框
        setTimeout(() => {
          this.$refs.personInput && this.$refs.personInput.focus()
        }, 100)
      })
    },
    // 更新数据
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          updateGreatEvent(tempData.id, tempData).then(() => {
            const index = this.list.findIndex(v => v.id === this.temp.id)
            this.list.splice(index, 1, tempData)
            this.dialogVisible = false
            this.$message({
              type: 'success',
              message: '更新成功!'
            })
          })
        }
      })
    },
    // 处理删除
    handleDelete(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGreatEvent(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList() // 重新加载数据
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
.form-inline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}

/* 弹窗样式调整 */
:deep(.el-dialog) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

:deep(.el-dialog__header) {
  padding: 16px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

:deep(.el-dialog__title) {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

:deep(.el-dialog__body) {
  padding: 20px 20px 10px;
}

:deep(.el-dialog__footer) {
  padding: 10px 20px 16px;
  border-top: 1px solid #f0f0f0;
}

:deep(.el-input__inner) {
  transition: border-color 0.2s;
}

:deep(.el-input__inner:focus) {
  border-color: #409EFF;
}
</style> 